<script>
import MeniVnos from "./Meni/Meni_vnos.vue";
import MeniPovezava from "./Meni/Meni_povezava.vue";
import MeniSplosno from "./Meni/Meni_splosno.vue";
import Upravljalci from "./Administracija/Upravljalci.vue";
import UpravljalciLetal from "./Administracija/UpravljalciLetal.vue";
import DvostopenjskaAvtentikacija from "./Administracija/Dvostopenjska.vue";
import VnosLicenc from "./Administracija/VnosLicenc.vue";
import Uporabniki from "./Administracija/Uporabniki.vue";
export default {
  components: {
    MeniVnos,
    MeniPovezava,
    MeniSplosno,
    Upravljalci,
    UpravljalciLetal,
    DvostopenjskaAvtentikacija,
    VnosLicenc,
    Uporabniki
  },
  emits: ['odjava'],
  data() {
    return {
      AdminPanel: true,
      MeniVnos: false,
      MeniPovezava: false,
      MeniSplosno: false,
      AdminUpravljalci:  false,
      AdminDvostopenjska: false,
      AdminLicence: false,
      AdminULetala: false,
      Uporabniki: false,
      Chosen: '',
    }
  },
  methods: {
    ChosenMenu(chosen) {
      this.AdminPanel = (chosen === 'AdminPanel');
      this.MeniVnos = (chosen === 'MeniVnos');
      this.MeniPovezava = (chosen === 'MeniPovezava');
      this.MeniSplosno = (chosen === 'SplosneNastavitve');
      this.AdminUpravljalci = (chosen === 'AdminUpravljalci');
      this.AdminDvostopenjska = (chosen === 'AdminDvostopenjska');
      this.AdminLicence = (chosen === 'AdminLicence');
      this.AdminULetala = (chosen === 'AdminULetala');
      this.Uporabniki = (chosen === 'Uporabniki');
    },
  }
}
</script>
<template>
  <!-- <div class="container p-2"> -->
  <!--         <div class="upper-cloud border-bottom-0 rounded-bottom-4 p-2">
              <button class="p-2 btn-back" @click.prevent="$emit('back')"><i class="fas fa-arrow-left fa-2x"></i></button>
              <h4 class="d-flex justify-content-center text-white">Nastavitve programa</h4>
          </div>
      <div class="hr-with-text">Meniji</div> -->
  <!--             <div v-if="AdminPanel" class="main-meni p-2" @click="ChosenMenu('MeniVnos')" style="color: white;">
                  <div class="container-fluid row p-2">
                      <div class="border border-0 main-meni-badge rounded-3 p-2 col-3 text-center align-middle" style="max-width: 50px; max-height: 50px;">
                          <i class="fas fa-bars fa-lg" style="vertical-align: -0.2667em;"></i>
                      </div>
                      <div class="col-9">
                          <div class="">Vnos</div>
                          <div class="fw-light opis-menija">Vnos menijev</div>
                      </div>
                  </div>
              </div> -->
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas" :class="{'fa-angle-double-left': !AdminPanel, 'fa-arrow-left': AdminPanel}"></i>
            <span>Na glavni meni</span>
          </button>
          &nbsp;
          <button v-if="!AdminPanel" class="back-btn" @click.prevent="ChosenMenu('AdminPanel')">
            <i class="fas fa-arrow-left"></i>
            <span>Na nastavitve</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">Nastavitve programa</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>
      </div>
    </div>
  </div>
  <main v-if="AdminPanel" class="main-content">
    <!-- Main Menu Section -->
    <div class="menu-section">
      <div class="menu-grid">
        <!-- Povezava menija -->
        <div class="menu-card" @click="ChosenMenu('MeniPovezava')">
          <div class="menu-icon">
            <i class="fas fa-network-wired"></i>
          </div>
          <div class="menu-content">
            <h3 class="menu-title">Povezava</h3>
            <p class="menu-description">Povezava uporabnika aplikacije z menijem</p>
          </div>
        </div>
        <!-- Upravljalci letališč -->
        <div class="menu-card" @click="ChosenMenu('AdminUpravljalci')">
          <div class="menu-icon">
            <i class="fas fa-user-shield"></i>
          </div>
          <div class="menu-content">
            <h3 class="menu-title">Upravljalci letališč</h3>
            <p class="menu-description">Urejanje upravljalcev letališč</p>
          </div>
        </div>
        <!-- Upravljalci letališč -->
        <div class="menu-card" @click="ChosenMenu('AdminULetala')">
          <div class="menu-icon">
            <i class="fas fa-plane"></i>
          </div>
          <div class="menu-content">
            <h3 class="menu-title">Upravljalci Letal</h3>
            <p class="menu-description">Urejanje upravljalcev letal, ki odobobrij nalog za posamezno letalo</p>
          </div>
        </div>
        <!-- Upravljanje 2FA -->
        <div class="menu-card" @click="ChosenMenu('AdminDvostopenjska')">
          <div class="menu-icon">
            <i class="fas fa-user-lock"></i>
          </div>
          <div class="menu-content">
            <h3 class="menu-title">Upravljanje dvostopenjskih avtentikacij</h3>
            <p class="menu-description">Izklop 2FA uporabniku</p>
          </div>
        </div>
        <!-- Upravljanje Licenc -->
        <div class="menu-card" @click="ChosenMenu('AdminLicence')">
          <div class="menu-icon">
            <i class="fas fa-key"></i>
          </div>
          <div class="menu-content">
            <h3 class="menu-title">Vnos licenc</h3>
            <p class="menu-description">Dodajanje novih licenc uporabnikom</p>
          </div>
        </div>
        <!-- Upravljanje Uporabnikov -->
        <div class="menu-card" @click="ChosenMenu('Uporabniki')">
          <div class="menu-icon">
            <i class="fas fa-users-cog"></i>
          </div>
          <div class="menu-content">
            <h3 class="menu-title">Uporabniki</h3>
            <p class="menu-description">Upravljanje uporabniških računov aplikacije</p>
          </div>
        </div>
      </div>
    </div>
  </main>
  <meni-vnos v-if="MeniVnos" @backToAdmin="ChosenMenu('AdminPanel')"/>

  <meni-povezava v-if="MeniPovezava" @backToAdmin="ChosenMenu('AdminPanel')"/>

  <meni-splosno v-if="MeniSplosno" @backToAdmin="ChosenMenu('AdminPanel')" />

  <upravljalci v-if="AdminUpravljalci"  @backToAdmin="ChosenMenu('AdminPanel')" />

  <upravljalci-letal v-if="AdminULetala"  @backToAdmin="ChosenMenu('AdminPanel')" />

  <dvostopenjska-avtentikacija v-if="AdminDvostopenjska"  @backToAdmin="ChosenMenu('AdminPanel')" />

  <uporabniki v-if="Uporabniki" @backToAdmin="ChosenMenu('AdminPanel')" />

  <vnos-licenc v-if="AdminLicence"  @backToAdmin="ChosenMenu('AdminPanel')" />
  <!-- </div> -->
</template>